<template>
	<div>
		<!-- Table Container Card -->
		<div class="m-2">
			<!-- Table Top -->
			<b-row>
				<!-- Date picker -->
				<b-col cols="12 pr-2" md="6">
					<b-row>
						<b-col md="5 p-0 mr-1">
							<label for="from-date">From Date</label>
							<b-form-datepicker
								id="from-date"
								:date-format-options="{
									year: 'numeric',
									month: 'short',
									day: '2-digit',
									weekday: 'short',
								}"
								placeholder="Choose a date"
								locale="en"
								v-model="search_filter.from_date"
							/>
						</b-col>
						<b-col md="5 p-0">
							<label for="to-date">To Date</label>
							<b-form-datepicker
								id="to-date"
								:date-format-options="{
									year: 'numeric',
									month: 'short',
									day: '2-digit',
									weekday: 'short',
								}"
								placeholder="Choose a date"
								locale="en"
								v-model="search_filter.to_date"
							/>
						</b-col>
						<b-col md="1 d-flex align-items-end">
							<b-button @click="getRawMaterialList()" variant="primary">Filter</b-button>
						</b-col>
					</b-row>
				</b-col>

				<!-- Search -->
				<b-col cols="12" md="6" class="pl-5 mt-2 d-flex justify-content-end align-items-center">
					<div>
						<b-form-input
							type="text"
							class="form-control"
							placeholder="Search"
							@input="getRawMaterialList()"
							v-model.trim="search_filter.input_field"
							style="border-radius: 4px"
						/>
					</div>
					<b-button @click="clearFilter" variant="secondary ml-1">Clear</b-button>
					<b-button v-b-modal.row-material variant="primary mr-1 ml-2">Add</b-button>
					<b-button @click="excelDownload()" variant="warning">
						<feather-icon icon="DownloadIcon" size="16" />
					</b-button>
				</b-col>
			</b-row>
		</div>

		<div v-if="rawMaterialColumns && rawMaterialColumns.total > 0">
			<b-table
				:items="rawMaterialColumns.data"
				id="medicineTable"
				responsive
				:fields="fields"
				empty-text="No matching records found"
				class="position-relative"
			>
				<template #cell(index)="data">
					<div class="ml-1">
						{{ rawMaterialColumns.from + data.index }}
					</div>
				</template>

				<template #cell(unit)="data">
					<div class="ml-1">
						{{ data.item.unit ? data.item.unit.name : "NA" }}
					</div>
				</template>

				<!-- Column: Actions -->
				<template #cell(actions)="data">
					<div class="text-nowrap">
						<feather-icon
							icon="EditIcon"
							size="16"
							v-b-modal.edit-raw-material
							@click="() => getRawMaterialById(data.item.id)"
						/>
						<b-tooltip title="Edit" :target="`invoice-row-${data.item.id}-preview-icon`" />
						<!--
            <feather-icon
              @click="() => setRawMaterialId(data.item.id)"
              icon="TrashIcon"
              size="16"
              class="mx-1"
              v-b-modal.modal-raw-material
            />
            <b-tooltip title="View" :target="`invoice-row-${data.item.id}-preview-icon`" />
            -->
					</div>
				</template>
			</b-table>

			<div class="mt-2 mb-5">
				<b-pagination
					:value="rawMaterialColumns.current_page"
					:total-rows="rawMaterialColumns.total"
					:per-page="rawMaterialColumns.per_page"
					align="right"
					@change="getRawMaterialList"
				/>
			</div>
		</div>

		<div v-else class="d-flex flex-column align-items-center py-5">
			<b-img :src="require('@/assets/images/svg/infographics/no_data_infographic.svg')" class="mr-2" />
			<h4 class="mt-2 Secondary">No Raw Material added yet</h4>
		</div>

		<!-- Raw Material modal -->
		<b-modal
			id="row-material"
			title="Row Material"
			ok-only
			@ok="addRawMaterial"
			ok-title="Submit"
			ref="my-modal"
			@show="resetModal"
			@hidden="resetModal"
			:no-close-on-backdrop="true"
		>
			<validation-observer ref="simpleRules">
				<b-form @submit="addRawMaterial" method="post">
					<b-form-group>
						<template v-slot:label> Enter Raw Material Name <span class="text-danger">*</span> </template>
						<validation-provider #default="{ errors }" name="Raw Material Name" rules="required">
							<b-form-input
								v-model="formData.name"
								name="rawMaterial"
								placeholder="Enter Raw Material Name"
								maxlength="30"
							/>
							<small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>
					</b-form-group>

					<b-form-group>
						<template v-slot:label> Unit Name <span class="text-danger">*</span> </template>
						<validation-provider #default="{ errors }" name="Unit Name" rules="required">
							<v-select
								v-model="formData.unit_id"
								:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
								:options="unitList"
								label="name"
								:reduce="(e) => e.id"
								:clearable="false"
							/>
							<small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>
					</b-form-group>
				</b-form>
			</validation-observer>
		</b-modal>

		<!-- Edit modal -->
		<b-modal
			id="edit-raw-material"
			title="Edit Raw Material"
			ok-only
			@ok="updateRawMaterial"
			ok-title="Submit"
			ref="my-modal"
			@show="resetModal"
			@hidden="resetModal"
			:no-close-on-backdrop="true"
		>
			<b-form method="post">
				<b-form-group label="Enter Raw Material Name" label-for="Enter Raw Material Name">
					<b-form-input
						v-model="formData.name"
						name="rawMaterial"
						placeholder="Enter Raw Material Name"
						maxlength="30"
					/>
				</b-form-group>

				<b-form-group label="Unit Name" label-for="Unit Name">
					<div class="form-label-group">
						<v-select
							:options="unitList"
							v-model="formData.unit_id"
							label="name"
							:reduce="(e) => e.id"
							:clearable="false"
						/>
					</div>
				</b-form-group>
			</b-form>
		</b-modal>

		<!-- delete modal -->
		<DeleteModal id="modal-raw-material" :onClicked="deleteMedicine" />
	</div>
</template>

<script>
import { required, regex } from "@validations";
import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DeleteModal from "@core/components/modal/Delete-modal.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
	components: {
		vSelect,
		DeleteModal,
		ValidationProvider,
		ValidationObserver,
	},
	data() {
		return {
			required,
			regex,
			selectedUnit: null,
			selectedRoute: null,
			unitList: null,
			routeList: null,
			company_name: null,
			value: null,
			page: null,
			searchQuery: null,
			formData: {
				name: null,
				unit: null,
				route: null,
				unit_id: null,
				route_type_id: null,
			},
			type: "feed",
			search_filter: {
				input_field: null,
				to_date: null,
				from_date: null,
			},
			fields: [
				{ key: "index", label: "S.no" },
				{ key: "name", label: "Name" },
				{ key: "unit", label: "Unit" },
				{ key: "actions", label: "Actions" },
			],
			medicineName: null,
			rawMaterialColumns: {},
			userData: null,
		};
	},
	created() {
		this.getUnit();
		// this.getRoute();
		this.userData = JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData") || "null");
		this.getRawMaterialList();
	},
	mounted() {
		this.getRawMaterialList();
	},
	methods: {
		moment() {
			return moment();
		},
		resetModal() {
			this.formData.name = "";
			this.formData.unit = "";
			this.formData.route = "";
			this.formData.expiry_date = "";
			this.formData.unit_id = "";
			this.formData.route_type_id = "";
		},
		getRawMaterialList(pageNo = 1) {
			const companyId = this.userData?.company?.id;
			const url = `web/company/${companyId}/raw-materials`;

			const queryParams = { page: pageNo };

			if (this.search_filter.input_field) queryParams.input_field = this.search_filter.input_field;
			if (this.search_filter.to_date) queryParams.to_date = this.search_filter.to_date;
			if (this.search_filter.from_date) queryParams.from_date = this.search_filter.from_date;

			axiosIns
				.get(this.addQueryString(url, queryParams))
				.then((response) => {
					this.rawMaterialColumns = response.data.raw_materials;
				})
				.catch((error) => {
					this.$refs?.setErrors?.(error?.response?.data?.errors);
				});
		},
		getUnit() {
			axiosIns
				.get(`web/units/${this.type}`)
				.then((response) => {
					this.unitList = response.data.unitList;
				})
				.catch((error) => {
					this.$refs?.setErrors?.(error?.response?.data?.error);
				});
		},

		async addRawMaterial(e) {
			e.preventDefault();
			const ok = await this.$refs.simpleRules.validate();
			if (!ok) return;

			const fd = new FormData();
			const form_data = this.objectToFormData(this.formData, fd);
			const companyId = this.userData?.company?.id;

			try {
				await axiosIns.post(`web/company/${companyId}/raw-materials`, form_data);
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "success", text: "Data successfully Added" },
				});
				this.$refs["my-modal"].hide();
				await this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
			} catch (error) {
				const data = error?.response?.data?.message || "Something went wrong";
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "danger", text: data },
				});
				await this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
			}
		},

		getRawMaterialById(id) {
			const companyId = this.userData?.company?.id;
			axiosIns
				.get(`web/company/${companyId}/raw-materials/${id}`)
				.then((response) => {
					this.formData = response.data.raw_material;
					this.id = id;
				})
				.catch((error) => {
					this.$refs?.setErrors?.(error?.response?.data?.error);
				});
		},

		async updateRawMaterial() {
			const companyId = this.userData?.company?.id;
			const form_data = new FormData();
			form_data.append("name", this.formData.name || "");
			form_data.append("unit_id", this.formData.unit_id || "");
			try {
				await axiosIns.post(`web/company/${companyId}/raw-materials/${this.id}/update`, form_data);
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "warning", text: "Data Updated Successfully" },
				});
				await this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
			} catch (error) {
				const data = error?.response?.data?.errors;
				const arr = data ? Object.values(data).flat().toString(",") : "Update failed";
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "danger", text: arr },
				});
				await this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
			}
		},

		setRawMaterialId(id) {
			this.id = id;
		},

		async deleteMedicine() {
			const data = new FormData();
			data.append("_method", "DELETE");

			try {
				await axiosIns.post(`web/medicines/${this.id}`, data);
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "danger", text: "Data successfully Deleted" },
				});
				await this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
			} catch (error) {
				const msg = error?.response?.data?.message || "Delete failed";
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "danger", text: msg },
				});
				await this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
			}
		},

		excelDownload() {
			// Format dates only for the request payload (don’t mutate state permanently)
			const payload = { ...this.search_filter };
			if (payload.from_date && payload.to_date) {
				payload.from_date = moment(payload.from_date).format("YYYY-MM-DD");
				payload.to_date = moment(payload.to_date).format("YYYY-MM-DD");
			}

			const order_filter_data = this.prepareForm(payload);

			axiosIns
				.post(`web/export-raw-material`, order_filter_data)
				.then((response) => {
					const tempLink = document.createElement("a");
					tempLink.style.display = "none";
					tempLink.href = response.data.file;
					tempLink.setAttribute("download", response.data.name);
					if (typeof tempLink.download === "undefined") {
						tempLink.setAttribute("target", "_blank");
					}
					document.body.appendChild(tempLink);
					tempLink.click();
					document.body.removeChild(tempLink);
					this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
				})
				.catch((error) => {
					const data = error?.response?.data?.errors;
					const arr = data ? Object.values(data).flat().toString(",") : "Export failed";
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: { icon: "CoffeeIcon", variant: "danger", text: arr },
					});
					this.search_filter.to_date = null;
					this.search_filter.from_date = null;
					this.search_filter.input_field = null;
					this.getRawMaterialList(this.rawMaterialColumns?.current_page || 1);
				});
		},

		clearFilter() {
			this.search_filter.input_field = "";
			this.search_filter.to_date = "";
			this.search_filter.from_date = "";
			this.getRawMaterialList(1);
		},
	},
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>